export const MAX_FREQUENT_OBJECTS = 4;
